import { IDatasetExecuteResponse } from '@kurtosys/types/api/dataset/IDatasetExecuteResponse.js';
import { QueryOutputType } from '@kurtosys/types/api/dataset/QueryOutputType.js';
import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { TConditionalHelperDependencies } from '@kurtosys/types/helpers/TConditionalHelperDependencies.js';
import { IExecutionOptions, IQueryContext, IQueryOptions } from '@kurtosys/types/query/index.js';
import { IQueryOptionsDataset } from '@kurtosys/types/query/options/IQueryOptionsDataset.js';

import { commonUtils, helpers } from '../../common/index.js';
import { queryHelper } from '../queryUtils/index.js';

import { BaseQuery } from './base/BaseQuery.js';

export class DatasetQuery extends BaseQuery<IQueryOptionsDataset> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}
	getOptions(): IQueryOptionsDataset {
		const { key, index, collectionItemConditional, options = {} } = this.queryOptions;
		return {
			key,
			index,
			collectionItemConditional,
			...(options.dataset || {}),
		} as any;
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const context = queryHelper.getContext(executionOptions, this.queryOptions);
		const { datasetKey, queryKey, key, index, collectionItemConditional, returnFullQuery = false } = this.options;
		const dataset = this.getDataset(context, datasetKey);
		if (dataset) {
			const query = dataset.queries.find((query) => query.key === queryKey);
			if (query) {
				let { results } = query;
				const { type } = query;
				if (Array.isArray(results) && results.length > 0) {
					if (key && type === QueryOutputType.arrayOfObjects) {
						results = (results as Record<string, any>[]).map((r) => r[key]);
					}
					if (!commonUtils.isNullOrUndefined(index) && index < results.length) {
						results = results[index] as any;
					} else if (collectionItemConditional) {
						const conditionalHelperDependencies: TConditionalHelperDependencies = {
							queryClass: this.dependencies.queryClass,
						};
						const conditionalHelper = new helpers.ConditionalHelper(
							conditionalHelperDependencies,
							{ conditions: [] },
							this.translationHelper,
						);
						results = results.filter((item) =>
							conditionalHelper.matches(item, collectionItemConditional, executionOptions),
						) as any;
					}
				}
				if (!returnFullQuery) {
					return results as any;
				}
				return query as any;
			}
		}
	}

	getDataset(context: IQueryContext, datasetKey: string): IDatasetExecuteResponse | undefined {
		if (context && context.datasets) {
			return context.datasets[datasetKey];
		}
	}
}
